/* eslint-disable camelcase */
import basketball_uniform from "./basketball-uniform";
import bodysuit from "./bodysuit";
import classic_polo_shirt from "./classic-polo-shirt";
import classic_tee from "./classic-tee";
import classic_woman_polo from "./classic-woman-polo";
import classic_woman_tee from "./classic-woman-tee";
import dog_tee from "./dog-tee";
import football_uniform from "./football-uniform";
import full_print_beanie from "./full-print-beanie";
import full_print_boy_tee from "./full-print-boy-tee";
import full_print_girl_tee from "./full-print-girl-tee";
import full_print_hoodie from "./full-print-hoodie";
import full_print_kids_sweatshirt from "./full-print-kids-sweatshirt";
import full_print_man_polo from "./full-print-man-polo";
import full_print_pencil_skirt from "./full-print-pencil-skirt";
import full_print_skirt from "./full-print-skirt";
import full_print_sport_tee from "./full-print-sport-tee";
import full_print_summer_dress from "./full-print-summer-dress";
import full_print_sweatshirt from "./full-print-sweatshirt";
import full_print_tanktop from "./full-print-tanktop";
import full_print_tee from "./full-print-tee";
import full_print_woman_hoodie from "./full-print-woman-hoodie";
import full_print_woman_polo from "./full-print-woman-polo";
import full_print_woman_sweatshirt from "./full-print-woman-sweatshirt";
import full_print_woman_tanktop from "./full-print-woman-tanktop";
import full_print_woman_tee from "./full-print-woman-tee";
import hoodie from "./hoodie";
import kids_football_uniform from "./kids-football-uniform";
import kids_tee from "./kids-tee";
import leggings from "./leggings";
import long_sleeve_dress from "./long-sleeve-dress";
import longsleeve from "./longsleeve";
import man_bomber from "./man-bomber";
import man_pajama_pants from "./man-pajama-pants";
import man_pants from "./man-pants";
import man_stretch_tee from "./man-stretch-tee";
import man_underpants from "./man-underpants";
import mask from "./mask";
import maternity_tee from "./maternity-tee";
import paired_tee from "./paired-tee";
import pleated_skirt from "./pleated-skirt";
import polo_shirt from "./polo-shirt";
import rashguard from "./rashguard";
import ringer_man_tee from "./ringer-man-tee";
import ringer_woman_tee from "./ringer-woman-tee";
import sleeveless_dress from "./sleeveless-dress";
import stretch_tee from "./stretch-tee";
import sweatshirt from "./sweatshirt";
import tanktop from "./tanktop";
import tee from "./tee";
import woman_bomber from "./woman-bomber";
import woman_pajama_pants from "./woman-pajama-pants";
import woman_pants from "./woman-pants";
import woman_polo from "./woman-polo";
import woman_tanktop from "./woman-tanktop";
import woman_tee from "./woman-tee";
import woman_underpants from "./woman-underpants";

export default {
  basketball_uniform,
  bodysuit,
  classic_polo_shirt,
  classic_tee,
  classic_woman_polo,
  classic_woman_tee,
  dog_tee,
  football_uniform,
  full_print_beanie,
  full_print_boy_tee,
  full_print_girl_tee,
  full_print_hoodie,
  full_print_kids_sweatshirt,
  full_print_man_polo,
  full_print_pencil_skirt,
  full_print_skirt,
  full_print_sport_tee,
  full_print_summer_dress,
  full_print_sweatshirt,
  full_print_tanktop,
  full_print_tee,
  full_print_woman_hoodie,
  full_print_woman_polo,
  full_print_woman_sweatshirt,
  full_print_woman_tanktop,
  full_print_woman_tee,
  hoodie,
  kids_football_uniform,
  kids_tee,
  leggings,
  long_sleeve_dress,
  longsleeve,
  man_bomber,
  man_pajama_pants,
  man_pants,
  man_stretch_tee,
  man_underpants,
  mask,
  maternity_tee,
  paired_tee,
  pleated_skirt,
  polo_shirt,
  rashguard,
  ringer_man_tee,
  ringer_woman_tee,
  sleeveless_dress,
  stretch_tee,
  sweatshirt,
  tanktop,
  tee,
  woman_bomber,
  woman_pajama_pants,
  woman_pants,
  woman_polo,
  woman_tanktop,
  woman_tee,
  woman_underpants
};
